import mixpanel from "mixpanel-browser";
import { Constants } from "./Constants";
import transport_alt from "./Content/images/transporter_logo.jpg";
import { toast } from "react-toastify";
import { Urls, LOGO_BASE_URL } from "./Urls";
import { get, getDatabase, onValue, ref, set } from "firebase/database";
import axios from "axios";
import React from "react";
import HelpActiveTenders from "./Components/HelpSection/HelpPages/HelpActiveTenders";
import HelpRFQ from "./Components/HelpSection/HelpPages/HelpRFQ";
import HelpRateCardScreen from "./Components/HelpSection/HelpPages/HelpRateCardScreen";
const FileUrl = LOGO_BASE_URL;

const database = getDatabase();
export const getTimeZone = () => {
  const datefortimezone = new Date();
  const new_date = datefortimezone.toString();
  const dateparts = new_date.split("(");
  const str2 = dateparts[1];
  const str3 = str2.split(")")[0];
  // const space = " ";
  const timezone = str3;
  return timezone;
};
export const getInitials = (name) => {
  if (!name) return "T";
  let ini = name.split(" ");
  let initials = "";
  if (ini.length > 1) initials = ini[0].charAt(0) + ini[1].charAt(0);
  else if (ini.length === 1) initials = ini[0].charAt(0);
  else if (ini.length === 0) initials = "T";
  return initials.toLocaleUpperCase();
};

export const profileLinkEncryptor = (transporterID = "", shouldEncode) => {
  let characters = "QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnm".split(
    ""
  );
  const generateRandomCharcter = () =>
    characters[Math.floor(Math.random() * characters.length)];
  if (shouldEncode) {
    let k = transporterID.split("");
    let encodedID = "";
    k.map((item, index) => {
      encodedID += item;
      for (let i = 0; i <= index; i++) {
        encodedID += generateRandomCharcter();
      }
    });
    return encodedID;
  } else {
    let decodedID = "";
    let startIndex = 0,
      nextIndex = 2;
    while (transporterID.length > startIndex) {
      decodedID += transporterID[startIndex];
      startIndex += nextIndex;
      nextIndex++;
    }
    return decodedID;
  }
};

export const checkSpecialChars = (stringToCheck) => {
  if (
    // new RegExp(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/).test(stringToCheck)
    new RegExp(/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/).test(stringToCheck)
  ) {
    return true;
  }
  return false;
};

// export const replaceValueForKey = (obj, key, value) => (obj[key] = value);

export const replaceValueForKey = (obj, key, value) => {
  const sqlInjectionPatterns = /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))/i;
  if (typeof obj === "object" && obj !== null) {
    if (sqlInjectionPatterns.test(value)) {
      toast.error("Suspicious Message!");
    } else {
      obj[key] = value;
    }
  }
};

export const hasValue = (value) => value && value.trim() && value.trim().length;

export const isValidPhoneNumber = (value) =>
  value &&
  !isNaN(parseInt(value)) &&
  (parseInt(value).toString().length === 10 ||
    parseInt(value).toString().length === 12);

export const isValidEmail = (value) =>
  value && new RegExp(Constants.EmailRegEx).test(value.trim());
export const isValidBusinessEmail = (value) => {
  let validEmail = true;
  let regexValidation =
    value && new RegExp(Constants.EmailRegEx).test(value.trim());
  if (!regexValidation) {
    validEmail = false;
  } else {
    let EmailDomain = value.split("@");
    if (EmailDomain.length < 2) {
      validEmail = false;
    } else {
      validEmail =
        Constants.restrictedDomains.filter(
          (email) => email.trim() === EmailDomain[1].trim()
        ).length === 0
          ? true
          : false;
    }
  }
  return validEmail;
};
export const generateReactSelectOptions = (opts = [], key, trimmed) =>
  opts.map((o) =>
    trimmed
      ? { label: o[key], value: o[key] }
      : { ...o, label: o[key], value: o[key] }
  );

export const generateReactSelectDefaultOptions = (opts) =>
  opts.map((v) => {
    return { label: v, value: v };
  });

export const getFileIconCss = (fileName) => {
  const invalidFile = Constants.FileTypes.find(
    (f) => f.extension === "invalid"
  );
  // console.log(fileName, "filename");
  if (!fileName || !fileName.trim()) return invalidFile;

  const ext = fileName.split(".").pop();
  const fileType = Constants.FileTypes.find(
    (f) => f.extension === ext.trim().toLowerCase()
  );

  return fileType || invalidFile;
};
export const getImageSrc = (logo) => {
  if (logo && logo.length > 1) return `${FileUrl}/${logo}`;
  return transport_alt;
};
export const imageFallBack = (e) => {
  e.target.src = transport_alt;
};
export const titleCase = (str) => {
  if (!str || typeof str !== "string") return "";
  const splitStr = str?.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i]?.charAt(0).toUpperCase() + splitStr[i]?.substring(1);
  }
  // Directly return the joined string
  return splitStr?.join(" ");
};
export const validateInputs = (
  origin,
  inputOrigin,
  destination,
  inputDestination,
  show = true
) => {
  const showToast = (message = "", show = true) => {
    return show ? toast.error(message) : "";
  };
  if (!origin || !destination || !inputDestination || !inputOrigin) {
    showToast("Please Select Location for origin or Destination", show);
    return 0;
  }
  if (inputOrigin.trim() !== origin.location_name.trim()) {
    showToast("Please Select Destination From Dropdown", show);
    return 0;
  }
  if (inputDestination.trim() !== destination.location_name.trim()) {
    showToast("Please Select Destination From Dropdown", show);
    return 0;
  }
  if (inputOrigin.trim().length === 0 || inputDestination.trim().length === 0) {
    showToast("Please Select Origin & Destinations From Dropdown Only", show);
    return 0;
  }
  if (inputOrigin.trim() === inputDestination.trim()) {
    showToast("Origin and Destination cannot be Same", show);
    return 0;
  }

  return 1;
};

export const getTransporterFilePath = function (id) {
  let transporterName = `transporter/${id}`;
  return transporterName;
};

// export const getCurrentUserData = function (
//   // keyToCompare,
//   // valueToCompare,
//   valueToFetch
// ) {
//   let userDetails = JSON.parse(sessionStorage.getItem("lsp_email"));
//   userDetails = userDetails["lsp_emails"];
//   let len = userDetails.length;
//   for (let i = 0; i < len; i++) {
//     return userDetails[0][valueToFetch];
//   }
//   return null;
// };

export const checkModuleAccess = function (
  access_control,
  contact_number,
  module
) {
  if (access_control && access_control?.length > 0) {
    for (let i = 0; i < access_control?.length; i++) {
      if (access_control[i]?.contact_number === contact_number) {
        for (let j = 0; j < access_control[i]?.modules?.length; j++) {
          if (
            access_control[i]?.modules[j]?.module_name === module &&
            access_control[i]?.modules[j]?.access === "no"
          ) {
            return false;
          }
        }
      }
    }
    return true;
  } else {
    return true;
  }
};

export const sqlInjectionPatterns =
  /(SELECT|INSERT|UPDATE|DELETE|DROP|TRUNCATE|CREATE|ALTER|GRANT|REVOKE|sleep\s*\(\s*\d+\s*\))/i;

export function testForSQLInjection(input) {
  return !sqlInjectionPatterns.test(input);
}

export const mixpanelTrack = ({
  id = "",
  name = "",
  event = "",
  screenName = "",
  moduleName = "",
  activityLog = "",
  data,
  definition = "",
}) => {
  mixpanel.track(event, {
    // distinct_id: 'unique client id',
    ApplicationName: `${Urls.appnamemixpanel}`,
    ScreenName: screenName,
    ModuleName: moduleName,
    ActivityLog: activityLog,
    Data: data,
    Definition: definition,
    TransporterName: name,
    TransporterId: id,
    ActivityType: "event_view",
  });
};

export const isValidGSTNumber = (gstNumber) => {
  if (!gstNumber) return false;
  // GST number format: 2 characters (state code) + 10 characters (PAN) + 1 character (entity type) + 1 character (check sum)
  const gstRegex =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;

  return gstRegex.test(gstNumber.toUpperCase());
};

/**
 * Retrieves the server time offset from the Firebase database and updates the provided offset setter.
 * @param {Function} setOffset - A function to set the offset value obtained from the server.
 * @returns {Function} A function to unsubscribe from the Firebase database reference when no longer needed.
 */
export const db_time_stamp = (setOffset, time) => {
  // const offsetRef = ref(database, ".info/serverTimeOffset"); //get the offset from firebase RTDB
  // return onValue(offsetRef, (snap) => { //listen to the changed value
  //   const offset = snap.val(); //snapshot of the changed value
  //   if (offset) { //check if offset is present
  //       setOffset(offset); //set offset into the state
  //   }
  // });

  // fetch(Urls.worldAPI)
  // .then(response => {
  //   // Check if the response is OK (status code 200)
  //   if (!response.ok) {
  //     throw new Error('Network response was not ok ' + response.statusText);
  //   }
  //   // Parse the JSON from the response
  //   return response.json();
  // })
  // .then(data => {
  //   // Extract the current time from the data
  //   const currentDateTime = data.dateTime;
  //   const apiDate = new Date(currentDateTime);
  //   const localDate = new Date();
  //   const resDifference = time - localDate.getTime()
  //   // Calculate the difference in milliseconds
  //   const timeDifference = localDate.getTime() - apiDate.getTime();
  //   const finalOffset = timeDifference + resDifference
  //   // Set the time difference in the offset state
  //   setOffset(finalOffset);
  // })
  // .catch(error => {
  //   // Handle any errors that occurred during the fetch operation
  //   console.error('There has been a problem with your fetch operation:', error);
  // });

  axios
    .get(Urls.worldAPI)
    .then((res) => {
      //   // Extract the current time from the data
      const currentDateTime = res?.data?.dateTime;
      const apiDate = new Date(currentDateTime);
      const localDate = new Date();
      const resDifference = localDate.getTime() - time;
      // Calculate the difference in milliseconds
      const timeDifference = apiDate.getTime() - localDate.getTime();
      const finalOffset = timeDifference + resDifference;
      // Set the time difference in the offset state
      setOffset(finalOffset);
    })
    .catch((error) => {
      // Handle any errors that occurred during the fetch operation
      console.error(
        "There has been a problem with your fetch operation:",
        error
      );
    });
};
/**


/**
 * Retrieves and filters chat messages for a specific auction and updates the state for message list and button class.
 * @param {string} auction_id - The ID of the auction to retrieve chat messages for.
 * @param {Function} setMessagelist - Function to update the state with the filtered message list.
 * @param {Function} setButtonClassName - Function to update the button's class name based on unread messages.
 * @returns {Function} A function to unsubscribe from the chat messages reference.
 */
export const getChats = (
  auction_id,
  setMessagelist,
  setButtonClassName,
  id,
  name,
  setTransporterAccess = () => {}
) => {
  if (id !== undefined || id !== null) {
    // Reference to the chat messages for the given auction
    const chat_db = ref(database, `chat/${auction_id}/message_list`);
    // Subscribe to changes in the chat messages
    const unsub = onValue(chat_db, (snapshot) => {
      setTransporterAccess(true);
      const chats = snapshot.val();
      if (chats) {
        // Filter messages to include only those from the local transporter ID
        const filtered_msgList = chats.filter(
          (item) => item?.transporter_id === id
        );
        setMessagelist(filtered_msgList);

        // Check for unread messages and update button class name accordingly
        const hasUnread = filtered_msgList?.[0]?.messages.filter(
          (m) => m?.read_status === false && m?.user_type === "company_user"
        );
        if (hasUnread) {
          if (hasUnread.length === 0 || !hasUnread || hasUnread === undefined) {
            if (setButtonClassName) {
              setButtonClassName("bg-colo"); // Set button class for no unread messages
            }
          }

          if (hasUnread?.length > 0) {
            if (setButtonClassName) {
              setButtonClassName("bg-colo-green"); // Set button class for unread messages
              return true;
            }
          }
        }
      }
    });

    // Return unsubscribe function to clean up listener when no longer needed
    return () => {
      unsub();
    };
  }
};

/**
 * Updates the status of a transporter in the database for a specific auction.
 * @param {string} name - The name of the transporter.
 * @param {string} id - The ID of the transporter.
 * @param {string} auction_id - The ID of the auction.
 * @param {string} status - The status to set for the transporter.
 * @param {boolean} auctionClosed - Indicates whether the auction is closed or not.
 * @returns {Promise<void>} A promise that resolves when the transporter status has been updated.
 */
export const updateTransporterStatusInDB = (
  name,
  id,
  userID,
  auction_id,
  status,
  auctionClosed
) => {
  if (id !== undefined || id !== null) {
    const newDatabase = getDatabase();
    // Reference to the transporter status for the given auction
    const transporters_status = ref(
      newDatabase,
      `auctions/${auction_id}/transporter_status`
    );
    if (auctionClosed === false) {
      return get(transporters_status).then((snapshot) => {
        let transporters = snapshot.val() || [];
        let transporterFound = false;

        // Update status if transporter is found
        if (transporters && transporters.length > 0) {
          transporters.map((item) => {
            if (item?.transporter_id === id) {
              item.status = status;
              transporterFound = true;
            }
          });
        }

        // Add new transporter if not found
        if (!transporterFound) {
          const entered_transporter = {
            transporter_name: name,
            user_id: userID,
            transporter_id: id,
            status: status,
          };
          transporters.push(entered_transporter);
        }

        return set(transporters_status, transporters);
      });
    }
  }
};
// export const updateTransporterStatusInDB = async (name, id, uid, auction_id, status, auctionClosed) => {
  // const auth = getAuth();
  // const newDatabase = getDatabase();
//   // Wait until the user is fully authenticated and the token is ready
//   const userPromise = new Promise((resolve) => {
//       const unsubscribe = onAuthStateChanged(auth, (user) => {
//           unsubscribe();
//           resolve(user);
//       });
//   });
//   const user = await userPromise;
//   if (!user) {
//       throw new Error("User is not authenticated");
//   }
//   if (auctionClosed) {
//       return;
//   }
//   // The SDK now has a valid token internally, no need for manual `auth`
//   const transporters_status = ref(newDatabase, `auctions/${auction_id}/transporter_status`);
//   const snapshot = await get(transporters_status);
//   let transporters = snapshot.val() || [];
//   let transporterFound = false;

//   transporters.forEach(item => {
//       if (item?.transporter_id === id) {
//           item.status = status;
//           transporterFound = true;
//       }
//   });

//   if (!transporterFound) {
//       const entered_transporter = {
//           user_id: uid,
//           transporter_name: name,
//           transporter_id: id,
//           status: status
//       };
//       transporters.push(entered_transporter);
// }

//   await set(transporters_status, transporters);
// };

const getStartingAmount = (auction_id, setbidAmount) => {
  const starting_amountRef = ref(
    database,
    `auctions/${auction_id}/starting_amount`
  );
  const unSub = onValue(starting_amountRef, (startingAmountSnap) => {
    const startingAmount = startingAmountSnap.val();
    if (startingAmount) {
      setbidAmount(startingAmount);
    }
  });
  return () => {
    unSub();
  };
};

/**
 * Updates the bid information and related data for a specific auction.
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setmyBid - Function to update the state with the current bid amount.
 * @param {Function} setL1_Quote - Function to update the state with the L1 quote amount.
 * @param {Function} setbidAmount - Function to update the state with the bid amount.
 * @param {number} number - The amount to subtract from the bid.
 * @param {Function} setrank - Function to update the state with the rank of the bid.
 * @param {string} id - The ID of the transporter.
 * @param {Function} setBid_updated - Function to update the state with the bid update status.
 * @param {Function} setTimerDate - Function to update the state with the auction timer date.
 * @param {Function} setreload_timer - Function to trigger a reload of the timer.
 * @param {string} reload_timer - The current state of the reload timer.
 * @param {number} myBid - The current bid amount of the user.
 * @param {boolean} [isAdvanced=false] - Flag indicating if advanced mode is used.
 * @returns {Function} A function to unsubscribe from the auction bid list reference.
 */
export const updateL1Quote = (
  auction_id,
  setmyBid,
  setL1_Quote,
  setbidAmount,
  number,
  setrank,
  id,
  setBid_updated,
  setTimerDate,
  setreload_timer,
  reload_timer,
  myBid,
  isAdvanced = false
) => {
  // Reference to the auction's starting amount and bid list
  if (id !== undefined || id !== null) {
    const auc = ref(database, `auctions/${auction_id}/bid_list`);

    // Subscribe to changes in the bid list
    const unsub = onValue(auc, (snapshot) => {
      const data = snapshot.val();
      if (data && data.length > 0) {
        let temp_valid_list = [];

        // Filter valid bids
        data.map((item) => {
          if (item.is_valid === true) {
            temp_valid_list.push(item);
          }
        });

        setL1_Quote(
          temp_valid_list.length > 0 ? temp_valid_list?.[0]?.bid_amount : 0
        );

        let list = [];
        // Filter bids for the current transporter
        data.map((item) => {
          if (item?.transporter_id === id) {
            list.push(item);
          }
        });

        if (!isAdvanced) {
          setbidAmount(
            data?.[0]?.bid_amount - number > 0
              ? data?.[0]?.bid_amount - number
              : 0
          );
        }

        let valid_list = [];
        // Filter valid bids for the current transporter
        list.map((item) => {
          if (item.is_valid === true) {
            valid_list.push(item);
          }
        });

        if (list.length > 0) {
          setBid_updated(list?.[0]?.is_valid ? "YES" : "NO");
        }

        setmyBid(valid_list.length > 0 ? valid_list?.[0]?.bid_amount : "");
        setrank(valid_list.length > 0 ? valid_list?.[0]?.rank : "");
      } else if (myBid === 0 && !data) {
        // Fetch and set the starting amount if no bids are available
        if ((id !== undefined || id !== null) && !isAdvanced) {
          getStartingAmount(auction_id, setbidAmount);
        }
        setBid_updated(null);
      }
    });

    // Update auction timestamp
    updatedTime(auction_id, setTimerDate, setreload_timer, reload_timer);
    // Return unsubscribe function to clean up listener when no longer needed
    return () => {
      unsub();
    };
  }
};

/**
 * Updates the auction end time based on resumed and paused timestamps.
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setTimerDate - Function to update the state with the auction end time.
 * @returns {Function} A function to unsubscribe from the updated time reference.
 */
export const updatedTime = (auction_id, setTimerDate, id) => {
  // Reference to the auction's updated time information
  if (id !== undefined || id !== null) {
    const updatedTimeRef = ref(database, `auctions/${auction_id}/closed_at_db`);
    // let updatedTimes = onValue(updatedTimeRef, (snap) => {
    //   const data = snap.val();
    //   if (data && data.resumed_at_db) { //check if resumed_at_db is present in data
    //     let paused_timestamp = new Date(data?.paused_at_db); // store paused_at_db in date format
    //     let resume_timestamp = new Date(data?.resumed_at_db); // store resumed_at_db in date format
    //     let diff = resume_timestamp.getSeconds() - paused_timestamp.getSeconds();
    //     let date = new Date(data?.live_timestamp_db);
    //     date.setMinutes(date.getMinutes() + Number(data?.auction_duration)); //add live timestamp and duration
    //     if (diff < 0) { //check if difference is smaller than 0
    //       date.setSeconds(date.getSeconds() + 60 + diff);
    //     } else {
    //       date.setSeconds(date.getSeconds() + diff);
    //     }
    //     setTimerDate(date);
    //   } else {
    //     let date = new Date(data?.live_timestamp_db); // store live_timestamp_db in date format
    //     if (data.live_timestamp_db === undefined) {
    //       // console.log("live timestamp db undefined (IF)");
    //       setTimerDate(undefined);
    //     } else {
    //       // console.log("else");
    //       date.setMinutes(date.getMinutes() + Number(data?.auction_duration)); //add live timestamp and duration
    //       setTimerDate(date);
    //     }
    //   }
    // });
    let updatedTimes = onValue(updatedTimeRef, (snap) => {
      const data = snap.val(); //snapshot of the value
      if (data) {
        let date = new Date(data);
        setTimerDate(date);
      }
    });
    return () => {
      updatedTimes();
    };
  }
  // Return unsubscribe function to clean up listener when no longer needed
};

/**
 * Listens for changes to the paused timestamp of an auction and updates the state.
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setPausedTime - Function to update the state with the paused timestamp.
 * @returns {Function} A function to unsubscribe from the paused timestamp reference.
 */
export const updatedPausedTImestamp = (auction_id, setPausedTime) => {
  // Reference to the auction's paused timestamp
  const timeStamp = ref(database, `auctions/${auction_id}/paused_at_db`);
  return onValue(timeStamp, (snap) => {
    const data = snap.val();
    if (data) {
      setPausedTime(new Date(data));
    }
  });
};

/**
 * Monitors the auction status and updates related states for pausing, closing, or activating the auction.
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setPausedAuction - Function to update the state indicating if the auction is paused.
 * @param {Function} setAuctionClosed - Function to update the state indicating if the auction is closed.
 * @param {Function} setreload_timer - Function to trigger a reload of the timer.
 * @param {string} reload_timer - The current state of the reload timer.
 * @param {Function} setPausedTimeStamp - Function to update the state with the paused timestamp.
 * @param {Function} getAuctionDetails - Function to retrieve auction details based on the auction start time and status.
 * @param {string} bucket - Identifier for the status of the auction ("paused" or other).
 * @returns {Function} A function to unsubscribe from the auction status reference.
 */
export const updateAuctionStatus = (
  auction_id,
  setPausedAuction,
  setAuctionClosed,
  setreload_timer,
  reload_timer,
  setPausedTimeStamp,
  getAuctionDetails,
  bucket,
  id
) => {
  // Reference to the auction's status
  if (id !== undefined || id !== null) {
    const statusRef = ref(database, `auctions/${auction_id}/auction_status`);
    return onValue(statusRef, (snap) => {
      const data = snap.val();
      if (data) {
        //check for the auction status, and set states according to the status
        if (data === "paused") {
          setPausedAuction(true);
          updatedPausedTImestamp(auction_id, setPausedTimeStamp);
          setreload_timer(!reload_timer); //reload timer
        } else if (data === "closed") {
          setAuctionClosed(true);
        } else if (data === "active") {
          setPausedAuction(false);
          // setreload_timer(!reload_timer);
          if (bucket === "paused") {
            //if paused bucket, call get auction API once auction gets live
            const start = new Date();
            getAuctionDetails(start, "active");
            // setreload_timer(!reload_timer)
          }
        }
      }
    });
  }
};

/**
 * Retrieves scroll duration and content for an auction and sets up listeners for updates.
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setscroll - Function to update the state with the scroll content.
 * @param {Function} setshowScroll - Function to control the visibility of the scroll.
 * @returns {Function} A function to unsubscribe from the scroll duration and content references.
 */
export const auctionDetailsFromDB = (
  auction_id,
  setscroll,
  setshowScroll,
  id,
  setTransporterAccess = () => {}
) => {
  // References to the auction's scroll duration and content
  if (id !== undefined || id !== null) {
    const scrollDurationRef = ref(
      database,
      `auctions/${auction_id}/scroll_duration`
    );
    const scrollContentRef = ref(
      database,
      `auctions/${auction_id}/inner_scroll_content`
    );
    let unsubscribeScrollDuration;
    let unsubscribeScrollContent;

    unsubscribeScrollDuration = onValue(scrollDurationRef, (snapshot) => {
      setTransporterAccess(true);
      const duration = snapshot.val();
      if (duration) {
        //if duration is present in RTDB
        unsubscribeScrollContent = onValue(scrollContentRef, (snapshot) => {
          const scroll_content = snapshot.val();
          if (scroll_content) {
            //if scroll content is present in RTDB
            setscroll(scroll_content);
            setshowScroll(true);
            if (duration !== "lot_duration") {
              //if lot duration not present, show scroll content for entire auction duration
              setTimeout(() => {
                setshowScroll(false);
              }, 60 * 1000 * duration);
            }
          }
        });
      }
    });

    // Return unsubscribe function to clean up listeners when no longer needed
    const unSubscribeFunctions = () => {
      if (unsubscribeScrollDuration) {
        unsubscribeScrollDuration();
      }
      if (unsubscribeScrollContent) {
        unsubscribeScrollContent();
      }
    };

    return unSubscribeFunctions;
  }
};

/**
 * Checks the block/unblock status of a transporter and updates the visibility state.
 * @param {string} auction_id - The ID of the auction.
 * @param {Function} setShowBlocked - Function to update the state indicating if the transporter is blocked.
 * @returns {Function} A function to unsubscribe from the transporter list reference.
 */
export const checkBlockUnblock = (auction_id, setShowBlocked, id) => {
  if (id !== undefined || id !== null) {
    // Reference to the list of transporters for the auction
    const listOfTransporters = ref(
      database,
      `auctions/${auction_id}/transporter_list`
    );
    const unSub = onValue(listOfTransporters, (snapshot) => {
      var data = snapshot.val();
      if (data) {
        // if transporter list is present
        Object.keys(data).some((key) => {
          const hasLsp = data?.[key]?.transporter_id === id; //check for the logged in transporter's ID
          const status = data?.[key]?.status;

          if (hasLsp && !status) {
            setShowBlocked(false);
            return true; // Return true to indicate that the transporter is unblocked
          }

          if (hasLsp && status === "block") {
            setShowBlocked(true);
            return true; // Return true to indicate that the transporter is blocked
          }

          if (hasLsp && status === "unblock") {
            setShowBlocked(false);
            return true; // Return true to indicate that the transporter is unblocked
          }

          return false; // Return false if none of the conditions are satisfied
        });
      }
    });

    // Return unsubscribe function to clean up listener when no longer needed
    return () => {
      unSub();
    };
  }
};

/**
 * Closes a modal by simulating a click on the close button.
 *
 * @param {string} closeButtonId - The ID of the close button element. Defaults to "close_contactus".
 */
export const closeModal = (closeButtonId = "close_contactus") => {
  const closeButton = document.getElementById(closeButtonId);
  if (closeButton) {
    closeButton.click();
  }
};
export const tpmpKeyMapper = {
  activeProcurement: {
    name: "Active Procurements",
    key: "activeprocurement",
    help_component: <HelpActiveTenders />,
  },
  singleProcurementScreen: {
    name: "RFQ Screen",
    key: "RFQ",
    help_component: <HelpRFQ />,
  },
  rateCardScreen: {
    name: "Rate Card Screen",
    key: "rateCard",
    help_component: <HelpRateCardScreen />,
  },
};

export function truncateText(text, maxLength = 30) {
  if (!text) return "";
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
}

export const isValidUrl = (urlString) => {
  try {
    new URL(urlString);
    return true;
  } catch (_) {
    return false;
  }
};


export const toTitleCase = (str) =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const getNameFromEmail = (email) => {
  if(!email) return ""; 
  const username = email.split("@")[0];
  const firstPart = username.split(/[._]/)[0];
  return firstPart.charAt(0).toUpperCase() + firstPart.slice(1).toLowerCase();
};